



























































import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  computed
} from "@vue/composition-api";
import { occPrimary } from "@/assets/styles/vars-for-script.scss";
import Layout from "@/components/Atoms/Layout/index.vue";
import OccToast from "@/components/Atoms/OccToast/index.vue";
import PageHeader from "@/components/Molecules/PageHeader/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import MessageTemplateList from "@/components/Pages/Scout/MessageTemplates/MessageTemplateList/index.vue";
import MessageTemplateRightDrawer from "@/components/Pages/Scout/MessageTemplates/MessageTemplateRightDrawer/index.vue";
import { TemplateRow } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateList/MessageTemplateRow/types";
import {
  getAllMessageTemplates,
  createMessageTemplate,
  deleteMessageTemplate
} from "@/grpc-web/scout/message_template";
import { toMessageTemplate, autoCloseToast } from "./methods";
import { MessageTemplate } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateRightDrawer/MessageTemplatePanel/types";
import DeleteConfirmModal from "@/components/Pages/Scout/elements/modals/DeleteConfirmModal/index.vue";

interface ToastState {
  isVisible: boolean;
  message: string;
}

export default defineComponent({
  name: "MessageTemplates",
  components: {
    DeleteConfirmModal,
    PageHeader,
    Layout,
    OccButton,
    MessageTemplateList,
    MessageTemplateRightDrawer,
    OccToast
  },
  setup() {
    const isShowNewMessageTemplateDrawer = ref<boolean>(false);
    const headerText = ref<string>("新規テンプレート作成");
    const selectedTemplate = ref<TemplateRow | null>(null);

    const handleClickedNewTemplate = () => {
      isShowNewMessageTemplateDrawer.value = true;
    };

    const isMouseOverHeader = ref<boolean>(false);
    const handleMouseOverHeader = () => {
      isMouseOverHeader.value = true;
    };

    const handleMouseLeaveHeader = () => {
      isMouseOverHeader.value = false;
    };

    const isMouseOverMessageTemplateList = ref<boolean>(false);
    const handleMouseOverMessageTemplateList = () => {
      isMouseOverMessageTemplateList.value = true;
    };

    const handleMouseLeaveMessageTemplateList = () => {
      isMouseOverMessageTemplateList.value = false;
    };

    const isMouseOverMessageTemplateHeader = ref<boolean>(false);
    const handleMouseOverMessageTemplateHeader = () => {
      isMouseOverMessageTemplateHeader.value = true;
    };

    const handleMouseLeaveMessageTemplateHeader = () => {
      isMouseOverMessageTemplateHeader.value = false;
    };

    const isMouseOverMessageTemplateDrawer = ref<boolean>(false);
    const handleMouseOverMessageTemplateDrawer = () => {
      isMouseOverMessageTemplateDrawer.value = true;
    };

    const handleMouseLeaveMessageTemplateDrawer = () => {
      isMouseOverMessageTemplateDrawer.value = false;
    };

    /**
     * 一覧ヘッダーの上にマウスがある、または、ページのヘッダーにマウスがある、かつ、テンプレートドロワーの上にマウスがない
     */
    const closableMessageTemplateDrawer = computed(() => {
      return (
        (isMouseOverMessageTemplateHeader.value || isMouseOverHeader.value) &&
        !isMouseOverMessageTemplateDrawer.value
      );
    });

    const shouldCloseEditMessageTemplate = ref<boolean>(false);
    const handleClickedOutside = () => {
      if (closableMessageTemplateDrawer.value) {
        isShowNewMessageTemplateDrawer.value = false;
        shouldCloseEditMessageTemplate.value = !shouldCloseEditMessageTemplate.value;
      }
    };

    const handleClickedCancelNewTemplate = () => {
      isShowNewMessageTemplateDrawer.value = false;
    };

    const handleClickedSendNewTemplate = async (template: MessageTemplate) => {
      await createMessageTemplate(template.name, template.body).finally(() => {
        isShowNewMessageTemplateDrawer.value = false;
      });

      // 上の通信が成功した時にトーストを表示する
      showToast("テンプレートを作成しました。");

      await loadMessageTemplates();
    };

    const isShowDeleteMessageTemplateConfirmModal = ref<boolean>(false);
    // 保存済みメッセージテンプレートの削除用オブジェクト
    const deleteMessageTemplateRow = ref<TemplateRow | undefined>(undefined);
    const handleDeletedTemplate = async (templateRow: TemplateRow) => {
      deleteMessageTemplateRow.value = templateRow;
      isShowDeleteMessageTemplateConfirmModal.value = true;
    };

    const handleClickedDeleteMessageTemplateConfirmModalCancel = () => {
      isShowDeleteMessageTemplateConfirmModal.value = false;
    };

    const handleSubmitDeleteMessageTemplateConfirmModal = async () => {
      if (deleteMessageTemplateRow.value === undefined) {
        return;
      }

      await deleteMessageTemplate(deleteMessageTemplateRow.value.id);

      isShowDeleteMessageTemplateConfirmModal.value = false;
      showToast("テンプレートを削除しました。");
      await loadMessageTemplates();
    };

    const deleteMessageTemplateRowName = computed(() => {
      if (deleteMessageTemplateRow.value === undefined) {
        return "";
      }

      return deleteMessageTemplateRow.value.title;
    });

    const handleUpdatedTemplate = async () => {
      showToast("テンプレートを保存しました。");
      await loadMessageTemplates();
    };

    const toastState = reactive<ToastState>({
      message: "",
      isVisible: false
    });

    const showToast = (message: string) => {
      toastState.message = message;
      toastState.isVisible = true;
      autoCloseToast(closeToast);
    };

    const closeToast = () => {
      toastState.isVisible = false;
    };

    const isLoadingMessageTemplates = ref<boolean>(false);
    const templates = ref<TemplateRow[]>([]);

    const loadMessageTemplates = async () => {
      isLoadingMessageTemplates.value = true;

      const loadedMessageTemplates = await getAllMessageTemplates().finally(
        () => {
          isLoadingMessageTemplates.value = false;
        }
      );
      templates.value = loadedMessageTemplates.map(v => toMessageTemplate(v));
    };

    onMounted(() => {
      loadMessageTemplates();
    });

    return {
      occPrimary,
      templates,
      isShowNewMessageTemplateDrawer,
      shouldCloseEditMessageTemplate,
      headerText,
      selectedTemplate,
      isLoadingMessageTemplates,
      toastState,
      showToast,
      closeToast,
      handleClickedNewTemplate,
      handleClickedSendNewTemplate,
      handleClickedCancelNewTemplate,
      handleDeletedTemplate,
      isShowDeleteMessageTemplateConfirmModal,
      handleClickedDeleteMessageTemplateConfirmModalCancel,
      handleSubmitDeleteMessageTemplateConfirmModal,
      deleteMessageTemplateRowName,
      handleUpdatedTemplate,
      handleMouseOverHeader,
      handleMouseLeaveHeader,
      handleMouseOverMessageTemplateDrawer,
      handleMouseLeaveMessageTemplateDrawer,
      handleMouseOverMessageTemplateList,
      handleMouseLeaveMessageTemplateList,
      handleMouseOverMessageTemplateHeader,
      handleMouseLeaveMessageTemplateHeader,
      handleClickedOutside
    };
  }
});
